export default __webpack_public_path__ + "static/media/fad-vroundswitch-off.b44a4ed4.svg";